import { AfterViewInit } from '@angular/core';
import { Component, Input, ViewChild } from '@angular/core';
import { UntypedFormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { QuillEditorComponent } from 'ngx-quill';

@Component({
  selector: 'input-text-rich',
  templateUrl: './input-text-rich.component.html',
  styleUrls: ['./input-text-rich.component.css']
})
export class InputTextRichComponent implements AfterViewInit {

  @Input() control: UntypedFormControl;
  @Input() id: string = '';
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() maxlength: number = 100;
  @Input() minlength: number = 0;
  @Input() showIconSuccess: boolean = false;
  @Input() class: string = 'form-control';
  @Input() messageRequired: string = '';
  @Input() messagePattern: string = '';

  @ViewChild('quilleditor') inputQuill: QuillEditorComponent;

  public characterAvailable: number = 100;

  public modules = {

    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['clean']
    ],
  };

  public theme: string = 'snow';
  public clipboard = { matchVisual: false };


  constructor() { }

  ngAfterViewInit() {
    this.control.addValidators(this.validateMaxLength());

    setTimeout(() => {
      this.inputQuill.quillEditor.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
        let ops = []
        delta.ops.forEach(op => {
          if (op.insert && typeof op.insert === 'string') {
            ops.push({
              insert: op.insert
            })
          }
        })
        delta.ops = ops
        return delta
      })
    }, 5000);
  }

  validateMaxLength(): ValidatorFn | ValidatorFn[] {

    return (): ValidationErrors | null => {

      var currentLength: number = 0;

      if (this.inputQuill?.quillEditor && this.inputQuill.quillEditor?.getLength() > 1) {
        currentLength = this.inputQuill.quillEditor.getLength() - 1;
      }

      const charAva = this.maxlength - currentLength;

      if (charAva < 0) {
        this.inputQuill.quillEditor.deleteText(this.maxlength, this.inputQuill.quillEditor?.getLength());
        this.characterAvailable = 0;
        return null;
      }

      this.characterAvailable = charAva;

      if (this.minlength > 0 && (this.inputQuill.quillEditor?.getLength() - 1) < this.minlength) {
        return { minlength: { requiredLength: this.minlength, actualLength: this.inputQuill.quillEditor.getLength() - 1 } }
      }

      if ((this.inputQuill.quillEditor?.getLength() - 1) > this.maxlength) {
        return { maxlength: { requiredLength: this.maxlength, actualLength: this.inputQuill.quillEditor?.getLength() - 1 } }
      }
      return null;
    }
  }
}
